<template>
  <div class="module-enrichment-container">
    <h2>Module Enrichment Analysis</h2>
    
    <div v-if="!taskId" class="input-section">
      <p>Input a set of Entrez gene symbols on each row in the textbox below.</p>
      <p>You can try a <a href="#" @click="loadExample">gene set example</a>.</p>
      
      <textarea 
        v-model="geneSymbols" 
        placeholder="Enter one gene symbol per line"
        rows="10"
        class="gene-input"
      ></textarea>
      
      <button 
        @click="submitAnalysis"
        class="submit-btn"
        :disabled="!geneSymbols"
      >
        Submit Analysis
      </button>
    </div>
    
    <div v-if="taskId">
      <div class="progress-section">
        <h3>Task Progress</h3>
        <div class="progress-bar">
          <div 
            class="progress" 
            :style="{ width: progress + '%' }"
          >{{ progress }}%</div>
        </div>
        <p v-if="status">Status: {{ status }}</p>
      </div>
      
      <div v-if="results" class="results-section">
        <h3>Analysis Results</h3>
        
        <!-- 表格数据 -->
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th v-for="col in results.table.columns" :key="col">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in results.table.rows" :key="index">
                <td v-for="col in results.table.columns" :key="col">
                  <span v-if="col != 'module' && col != 'singleCell'">
                    {{ row[col] }}
                  </span>
                  <span v-if="col == 'module'">
                    <a :href="'/#/singleCell/detail/' + row['singleCellId'] + '?moduleNumber=' + row['moduleNumber']" >
                      {{ row[col] }}
                    </a>
                  </span>
                  <span v-if="col == 'singleCell'">
                    <a :href="'/#/singleCell/detail/' + row['singleCellId'] + '?moduleNumber=' + row['moduleNumber']" >
                      {{ row[col] }}
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- HTML图 -->
        <div class="html-viewer">
          <h4>Visualization</h4>
          <iframe 
            :src="results.htmlUrl" 
            width="100%" 
            height="500px"
            frameborder="0"
          ></iframe>
        </div>
        
        <!-- 下载链接 -->
        <div class="download-section">
          <a 
            :href="results.downloadUrl" 
            class="download-btn"
            download="download_all.txt"
          >
            Download all results
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleEnrichment',
  data() {
    return {
      geneSymbols: '',
      taskId: this.$route.query.taskId,
      progress: 0,
      status: '',
      results: null,
      checkInterval: null,
    }
  },
  created() {
    if (this.taskId) {
      this.startProgressCheck();
    }
  },

  methods: {
    loadExample() {
      this.geneSymbols = 'SLC8A1\nMSR1\nTBXAS1\nSLCO3A1\nPHACTR1\nPLCL1\nZC3HAV1\nUBASH3B\nMYO5A\nANKUB1\nSPIRE1\nLINC01099\nDEFB1\nPDZRN3\nCCDC178\nSPP1\nPTPRM\nSMIM14\nCLTA\nTNFAIP6\nITGB2\nGAS2L3\nSF3B5\nSLC27A1\nPKN3\nINPP4A\nMOB3A\nSGSM1\nOSBPL3';
    },
    async submitAnalysis() {
    //   const genes = this.geneSymbols.split('\n').filter(g => g.trim());
      
      try {
        // 调用API创建任务
        const res = await this.$ajax.post('job/create', { genes: this.geneSymbols });
        window.location.href = `/#/job?taskId=${res.data}`;
        window.location.reload()
        this.taskId = res.data;
        
      } catch (error) {
        console.error('Error submitting analysis:', error);
      }
    },
    
    startProgressCheck() {
      this.checkInterval = setInterval(async () => {
        const res = await this.$ajax.get(`job/status/${this.taskId}`);
        this.progress = res.data.progress * 100;
        
        // 根据状态码显示对应的状态文本
        switch(res.data.status) {
          case 0: this.status = 'Created'; break;
          case 1: this.status = 'Ready'; break;
          case 2: this.status = 'Running'; break;
          case 3: this.status = 'Success'; break;
          case 4: this.status = 'Timeout'; break;
          case 5: this.status = 'Failed'; break;
          default: this.status = 'Unknown'; break;
        }
        
        if (res.data.status == 3) {
          clearInterval(this.checkInterval);
          this.results = {
            table: {
              columns: ['singleCell', 'module', 'score', 'pvalue', 'enrichedCellType', 'enrichedPathway'],
              rows: res.data.results
            },
            htmlUrl: res.data.barplot.url,
            downloadUrl: res.data.downloadFile.url
          };
        } else if (res.data.status == 5) {
          clearInterval(this.checkInterval);
        }
      }, 3000);
    }
  },
  
  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
}
</script>

<style scoped>
.module-enrichment-container {
  width: 90%;
  margin: 0 auto;
  padding: 30px;
}

.gene-input {
  width: 100%;
  padding: 15px;
  margin: 15px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  min-height: 300px;
}

.submit-btn {
  background-color: #176b6e;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin: 20px auto;
  display: block;
}

.submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.input-section {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.input-section p {
  font-size: 16px;
  margin-bottom: 10px;
}

.progress-section {
  margin: 30px 0;
}

.progress-bar {
  width: 100%;
  height: 30px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin: 10px 0;
  overflow: hidden;
}

.progress {
  height: 100%;
  background-color: #176b6e;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.3s;
}

.results-section {
  margin-top: 30px;
}

.table-container {
  margin: 20px 0;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

th {
  background-color: #f5f5f5;
}

.html-viewer {
  margin: 30px 0;
}

.download-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #176b6e;
  color: white;
  text-decoration: none;
  border-radius: 4px;
}
</style>